import { Divider, Flex, Select } from "antd"
import TextArea from "antd/lib/input/TextArea"
import Title from "antd/lib/typography/Title"
import { postOrderMoniteringAPI } from "api/order-book"
import { SimpleModal } from "components/containers"
import { ConfirmButton, DataGrid, FillButton } from "components/elements"
import { watchReasonOptions } from "data/options"
import { useState } from "react"

const OrderMoniteringTable = ({ subject, data, tmpOrderNo, memberIdx, fnComplete, isView }) => {
  const filterData = data?.filter(it => it.result)

  const [modal, setModal] = useState(false)
  const [option, setOption] = useState(null)

  const fnOpen = () => {
    fnOptionInit()
    setModal(true)
  }

  const fnClose = () => {
    setModal(false)
  }

  const fnOptionInit = () => {
    filterData?.map(it => {
      setOption(prev => prev
        ? {...prev, [it.product_cd]: { reason: it.reason, reason_detail: it.reason_detail }}
        : {[it.product_cd]: { reason: it.reason, reason_detail: it.reason_detail }}
      )
    })
  }

  const fnSubmitReason = async () => {
    for (const it of filterData) {
      if (!option?.[it.product_cd]?.reason) {
        alert('사유를 선택하세요.')
        return
      } else if (option?.[it.product_cd]?.reason === '6' && !option?.[it.product_cd]?.reason_detail) {
        alert('상세사유를 입력해주세요.')
        return
      }
    }

    for (const key in option) {
      const body = {
        ...option[key],
        tmp_order_no: tmpOrderNo,
        member_idx: memberIdx,
        product_cd: [key]
      }
      if (option?.[key]?.reason !== '6') delete body.reason_detail
      try {
        await postOrderMoniteringAPI(body)
        fnClose()
        if (fnComplete) fnComplete()
      } catch (err) {
        console.error(err)
      }
    }
  }

  const resaonColumn = [
    { title: '교재명', align: 'center', width: '30%', dataIndex: 'product_name' },
    { title: '사유', align: 'center', width: '70%',
      render: (text, record) => 
        <Flex vertical={true} align={'center'} gap={'small'}>
          <Select
            style={{ width: '70%' }}
            placeholder={'선택'}
            value={option?.[record.product_cd]?.reason}
            options={watchReasonOptions?.slice(1)}
            onSelect={(v) => setOption({...option, [record.product_cd]: {...option?.[record.product_cd], reason: v}})}
          />
          {option?.[record.product_cd]?.reason === '6' && 
            <TextArea 
              style={{ resize: 'none' }}
              rows={6} 
              maxLength={300} 
              value={option?.[record.product_cd]?.reason_detail}
              onChange={e => setOption({...option, [record.product_cd]: {...option?.[record.product_cd], reason_detail: e.target.value}})}
            />
          }
        </Flex>
    }
  ]

  return (
    <>
      <div style={{ width: '160px', border: '1px solid black' }}>
        <Flex vertical align={'center'} size={0} style={{  backgroundColor: 'var(--color-gray08)', padding: '3px 0', height: '43px' }}>
          <span>{data?.[0]?.create_date}</span>
          <span>{data?.[0]?.book_cate1}</span>
        </Flex>

        {subject?.map(it => {
          const target = data?.find(item => item.book_cate2_code === it.book_cate2_code)
          const style = {}

          if (target && target?.result) {
            if (!isView) style.cursor = 'pointer'
            switch (target?.result) {
              case 1:
                style.color = 'var(--color-gray09)'
                style.textDecoration = 'underline'
                style.backgroundColor = 'var(--color-red08)'
                break;
              case 2:
                style.color = 'blue'
                style.textDecoration = 'underline'
                style.backgroundColor = 'var(--color-red08)'
                break;
              case 3:
                style.backgroundColor = 'var(--color-yellow01)'
                break;
              case 4:
                style.backgroundColor = 'var(--color-gray10)'
                break;
              case 5:
                style.color = 'red'
                style.textDecoration = 'line-through'
                style.backgroundColor = 'var(--color-gray10)'
                break;
              case 6:
                style.backgroundColor = 'var(--color-blue04)'
                break;
              case 7:
                style.border = '3px solid var(--color-green01)'
                break;
              default:
            }
            if (target?.reason) {
              style.color = 'var(--color-blue01)'
              style.textDecoration = 'underline'
            }
          }

          return (
            <div 
              style={{ 
                borderTop: '1px solid black', 
                textAlign: 'center', 
                padding: '2px 0', 
                height: '24px',
                ...style
              }}
              onClick={style?.cursor && fnOpen}
            >
              {target?.product_name}
            </div>
          )
        })}
      </div>

      <SimpleModal
        open={modal}
        width={'40%'}
        onClose={fnClose}
        footer={[
          <Flex justify={'center'}>
            <ConfirmButton label={'전송'} onClick={fnSubmitReason} />
            <FillButton label={'닫기'} color={'var(--color-gray03)'} backgroundColor={'var(--color-gray04)'} onClick={fnClose} />
          </Flex>
        ]}
        >
        <Title level={5}>교재주문 모니터링 사유 작성</Title>
        <Divider className="divider" />

        <DataGrid
          bordered
          columns={resaonColumn}
          data={filterData}
        />
      </SimpleModal>
    </>
  )
}

export default OrderMoniteringTable